const imp = () => import(/* webpackChunkName: "loadSprite_module_color"*/  "../sprite/loadSprite_module_color");
const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-Full-text-annotation": imp,
  "Icon-H5-Related-matters": imp,
  "Icon-H5-picture": imp,
  "Icon-H5-voice": imp,
  "Icon-Voice-to-text": imp,
  "Icon-at": imp,
  "Icon-enclosure": imp,
  "Icon-expression": imp,
  // "Icon-initialization": imp,
  // "Icon-Initialization-settings": imp,
}
export default loadMap;